var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", { staticClass: "table__row" }, [
    _c("td", { staticClass: "table__cell--date" }, [
      _vm._v(_vm._s(_vm.credit.date))
    ]),
    _vm._v(" "),
    _c("td", { staticClass: "table__cell--amount" }, [
      _vm._v(_vm._s(_vm.credit.orig_amount))
    ]),
    _vm._v(" "),
    _c("td", { staticClass: "table__cell--amount" }, [
      _vm._v(_vm._s(_vm.credit.used_amount))
    ]),
    _vm._v(" "),
    _c("td", { staticClass: "table__cell--remaining" }, [
      _vm._v(_vm._s(_vm.credit.remaining))
    ]),
    _vm._v(" "),
    _c("td", { staticClass: "table__cell table__cell--action" })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }